import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Form as FormAnt, Upload } from "antd";
import { InboxOutlined, FilePdfOutlined, FileWordOutlined, FileOutlined, DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { misContribuyenteService } from "../../../_services/misContribuyentes.service";
import { editInmueble } from "../../../redux/Sections/MisContribuyentes/actions";
import { setLoading } from "../../../redux/Loading/actions";

const EditarInmueble = ({ show, handleClose, getData, editInmueble, inmueble, setInmueble, setInmuebles, setLoading }) => {
  const [data, setData] = useState({
    inmueble: "",
    recurso: "",
    caracter: "",
    observaciones: "",
  });
  const [documentos, setDocumentos] = useState([]);

  useEffect(() => {
    setData({
      id: inmueble.id,
      index: inmueble.index,
      inmueble: inmueble.inmueble,
      recurso: inmueble.recurso,
      caracter: inmueble.caracter,
      observaciones: inmueble.observaciones,
    });
  }, [inmueble]);

  const onSubmit = async () => {
    try {
      if (inmueble.id) {
        setLoading(true);

        editInmueble({ ...data, documentos: documentos.filter(e => !e.id) })
          .then(({ success }) => {
            if (success) {
              Swal.fire({
                title: "",
                text: "Exito",
                icon: "success",
                didClose: () => {
                  getData();
                  handleClose();
                }
              });
            }
            else {
              Swal.fire({
                title: "",
                text: "ERROR",
                icon: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
            Swal.fire({
              title: "",
              text: "ERROR",
              icon: "error",
            });
          });
      }
      else {
        setInmuebles((prev) => prev.map((e, i) => {
          if (i === inmueble.index) {
            return {
              index: data.index,
              inmueble: data.inmueble,
              recurso: data.recurso,
              caracter: data.caracter,
              observaciones: data.observaciones,
              documentos: [...inmueble.documentos, ...documentos]
            };
          }
          else {
            return e;
          }
        }));
        handleClose();
      }
    }
    catch (err) {
      setLoading(false);
    }
  };


  const normFile = (e) => {
    setDocumentos(e.fileList);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };


  const handleRemove = ({ uid }) => {
    setInmueble(() => {
      return {
        ...data,
        documentos: inmueble.documentos.filter((e) => e.uid !== uid)
      };
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "¿Esta seguro de eliminar este documento?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let response = await misContribuyenteService.deleteDocumento(id);

        if (response.ok) {
          getData();
          let data = await misContribuyenteService.getInmueble(inmueble.id);
          setInmueble(data);

          return Swal.fire(
            "Exito!",
            "Los datos es guardaron correctamente.",
            "success"
          );
        }
        else {
          return Swal.fire(
            "Error!",
            "Ocurrio un error, intentelo nuevamente.",
            "error"
          );
        }
      }
    });
  };


  return (
    <Modal
      animation={false}
      show={show}
      onHide={handleClose}
      size="xl"
      className="contribuyente-modal"
      backdrop="static"
    >
      <Modal.Header closeButton />
      <Modal.Body>

        <Form className="contribuyente-form">
          <Row style={{ marginBottom: 50 }}>
            <Col sm={12} md={6}>
              <div className="contribuyente-title">
                <span>Editar inmueble</span>
              </div>
            </Col>
          </Row>
          <Row className="pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>
                Inmueble
              </Form.Label>
              <Form.Control
                name="inmueble"
                value={data.inmueble || ""}
                onChange={handleChange}
              />
            </Col>
          </Row>
          <br />
          <Row className="pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>
                Recurso
              </Form.Label>
              <Form.Control
                name="recurso"
                value={data.recurso || ""}
                onChange={handleChange}
              />
            </Col>
          </Row>
          <br />
          <Row className="pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>
                Caracter
              </Form.Label>
              <Form.Control
                name="caracter"
                value={data.caracter || ""}
                onChange={handleChange}
              />
            </Col>
          </Row>
          <br />
          <Row className="pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-2">Observaciones</Form.Label>
              <Form.Control
                as="textarea"
                name="observaciones"
                rows={5}
                value={data.observaciones || ""}
                onChange={handleChange}
              />
            </Col>
          </Row>
          <Row className="mt-3 mb-3 pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-2">
                Documentos:
              </Form.Label>
              {inmueble.documentos?.length ? (
                <div className="mt-2">
                  {inmueble.documentos.map((e, i) => {
                    const pathTo = `${data.inmueble}_${data.recurso}/${e.documento}`;

                    return (
                      <>
                        {inmueble.id ? (
                          <Row key={e.documento + i}>
                            <Col style={{ display: "list-item", marginLeft: 20 }}>
                              <a
                                href={"https://staticcontent.sannicolasciudad.gob.ar/images/gestion-deudas/" + pathTo}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {e.documento}
                              </a>
                            </Col>
                            <Col>
                              <DeleteOutlined onClick={() => handleDelete(e.id)} style={{ color: "red" }} />
                            </Col>
                          </Row>
                        ) : (
                          <Row key={e.name + i}>
                            <Col style={{ display: "list-item", marginLeft: 20 }}>
                              {e.name}
                            </Col>
                            <Col>
                              <CloseOutlined onClick={() => handleRemove(e)} style={{ color: "red" }} />
                            </Col>
                          </Row>
                        )}
                      </>
                    );
                  })}
                </div>
              ) : null}
            </Col>
          </Row>

          <br />
          <Row className="pb-2">
            <Col sm={12} md={12} >
              <FormAnt.Item>
                <Form.Label className="mb-2">
                  Subir archivos:
                </Form.Label>
                <FormAnt.Item name="dragger" valuePropName="fileList" getValueFromEvent={normFile} >
                  <Upload.Dragger
                    multiple
                    beforeUpload={() => false}
                    name="files"
                    listType="picture"
                    iconRender={(f) => {
                      if (f.type === "application/pdf") {
                        return <FilePdfOutlined style={{ color: "#FA0F00" }} />;
                      }
                      else if ((f.type === "application/msword") || (f.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) {
                        return <FileWordOutlined style={{ color: "#185ABD" }} />;
                      }
                      else {
                        return <FileOutlined />;
                      }
                    }}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Haga click o arrastre el archivo a esta área para cargarlo</p>
                    <p className="ant-upload-hint">Soporte para una carga única o masiva.</p>
                  </Upload.Dragger>
                </FormAnt.Item>
              </FormAnt.Item>
            </Col>
          </Row>

          <Row className="justify-content-end">
            <Col style={{ maxWidth: 190 }}>
              <Button
                className="custom-button"
                onClick={onSubmit}
              >
                <span className="ml-2">Guardar Cambios</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 140 }}>
              <Button
                className="danger-button ml-2"
                variant="danger"
                onClick={handleClose}
              >
                <span className="ml-2">Cancelar</span>
              </Button>
            </Col>
          </Row>
        </Form>

      </Modal.Body>
    </Modal>
  );
};


const mapDispatchToProps = (dispatch) => {
  return {
    editInmueble: (id) => dispatch(editInmueble(id)),
    setLoading: (value) => dispatch(setLoading(value)),
  };
};

export default connect(null, mapDispatchToProps)(EditarInmueble);
